import React from "react";
import OurMission from "../components/OurMission";
import DrInfo from "../components/DrInfo";
import ServiceCards from "../components/ServiceCards";
import "../Styles/SpecialistScroller.css";
import LatestTechnology from "../components/LatestTechnology";

const About = () => {
  return (
    <div>
      <OurMission />
      <div className="specialist-section no-bg">
        <h2>
          Meet Our <span>Specialists</span>
        </h2>
        <p>
          We use only the best quality materials on the market in order to
          provide the best products to our patients.
        </p>
      </div>

      <DrInfo />
      <LatestTechnology />
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          background: "rgba(1, 22, 50, 1)",
          padding: "40px 20px",
          borderRadius: "12px",
        }}
      >
        <ServiceCards count={3} />
      </div>
    </div>
  );
};
// This line is comment
export default About;
